import React, { useContext, useState, useEffect, useRef } from 'react';
import ApiService from '../../functions/apiService';
import { Grid, Avatar, Chip, Table, TableBody, Switch, TableCell, CircularProgress , TableContainer, TableHead, TableRow, Card, CardContent, Pagination , Checkbox } from '@mui/material';
import { Link } from "react-router-dom";
import moment from "moment";
import { toast } from 'react-toastify';
import AuthContext from '../../context/AuthContext';
import { useReactToPrint } from "react-to-print";

const ChecklistCard = (props) => {
	const { permission, user } = useContext(AuthContext);
	const [loading, setLoading] = useState(false);
	const { data, setTitle, getChecklistDetails, setShowModal, getChecklist, openDuplicateModal } = props;
	const [checklistAllData , setChecklistAllData]  = useState([]);
	const [checklistDetails, setChecklistDetails] = useState([]);
	const printRef = useRef();

	const columns = ["Duration", "Created on", "Parent Location", "Assigned to", "Created by"]

	const updateChecklistStatus = (id, currStatus) => {
		var newStatus = 'active'
		if (currStatus == 'active') {
			newStatus = 'inactive'
		}
		const body = {
			"id": id,
			"status": newStatus
		}
		ApiService.post('/checklist/update-status', body)
			.then((data) => {
				getChecklist(false)
				toast.success(data?.message)

			})
			.catch((e) => {
				setLoading(false);
			})
	}

	const deleteChecklist = (id) => {
			const body = {
				'id': id,
			}
			ApiService.post('/checklist/delete', body)
				.then(( data ) => {
					toast.success(data?.message)
					getChecklist(false)
					setLoading(false);
				})
				.catch(( error ) => {
					toast.error(error?.data?.message)
					setLoading(false);
				})
		}

	const getChecklistData = (id) => {
		if (id) {
			ApiService.get('/checklist/edit_details/' + id)
				.then(async ({ data }) => {
					setChecklistAllData(data?.data || [])
				})
				.catch((e) => {
					console.error(e || 'error')
				})
		}
	}

	const getChecklistDetailsNew = (id) => {
		const body = {
			"checklist_id": id
		}
		ApiService.post('/checklist/details', body)
			.then(({ data }) => {
				setChecklistDetails(data)
				setLoading(false);
			})
			.catch((e) => {
				setLoading(false);
			})
	}
	
	const handlePrint = useReactToPrint({
		contentRef: printRef,
		onBeforePrint: () =>
		new Promise((resolve) => {
			document.fonts.ready.then(() => resolve());
		}),
	});
	
	let printFunction = () => {
		handlePrint()
	}

	// const handleChecklistData = (id) =>{
	// 	getChecklistData(id)
	// 	getChecklistDetailsNew(id)
	// 	setLoading(true)
	// 	setTimeout(()=>{
	// 		printFunction()
	// 		setLoading(false)
	// 	} , 2000)
	// }

	const handleChecklistData = async (id) => {
		if (!id) return;
		setLoading(true);

		try {
			await Promise.all([
				getChecklistData(id),
				getChecklistDetailsNew(id)
			]);

			setTimeout(()=>{
				printFunction()
				setLoading(false)
			} , 2000)
		} catch (error) {
			console.error(error);
		} finally {
			setLoading(false);
		}
	};

	return (
		<>
		
			<div className="font-fam">
				<Grid container>
					<Grid item xs={12} className="mt-4">
						<Card className="mt-2" sx={{ backgroundColor: 'rgba(245, 245, 245, 0.4)', border: '1px solid #cccccc', borderRadius: '12px' }} elevation={0}>
							<CardContent>
								<div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #cccccc' }}>
									<p style={{ fontSize: '16px', fontWeight: '550', fontFamily: 'karla' }}>{data?.title}</p>
									<div className="d-flex font-fam" style={{ gap: 5 }}>

										{(permission?.includes("Checklist_Auth")) &&
											<Chip
												variant="outlined"
												sx={{
													backgroundColor: '#EAECF0',
													color: '#2B3F6C',
													border: '1px solid #2B3F6C',
													cursor: 'pointer'
												}}
												avatar={<Avatar src="/images/copy.svg" style={{ width: 20, height: 20, padding: 2 }} />}
												label={'Duplicate'}
												onClick={() => openDuplicateModal(data?.id)}
											/>
										}

										{(permission?.includes("Checklist_Auth")) &&
											<div>
												{(permission && permission.includes('Emp_Auth')) || data?.created_by == user?.Emp_Code ?
													<Link to={`/firehouse/edit-checklist/${data?.id}`}>
														<Chip
															variant="outlined"
															sx={{
																backgroundColor: '#EAECF0',
																color: '#2B3F6C',
																border: '1px solid #2B3F6C',
																cursor: 'pointer'
															}}
															avatar={<Avatar src="/images/edit.png" style={{ width: 20, height: 20, padding: 2 }} />}
															label={'Edit'}
														/>
													</Link>
													:
													<Chip
														variant="outlined"
														sx={{
															backgroundColor: '#EAECF0',
															color: '#2B3F6C',
															border: '1px solid #2B3F6C',
														}}
														avatar={<Avatar src="/images/edit.png" style={{ width: 20, height: 20, padding: 2 }} />}
														label={'Edit'}
														disabled={true}
													/>
												}
											</div>
										}

										<Chip
											variant="outlined"
											sx={{
												backgroundColor: '#EAECF0',
												color: '#2B3F6C',
												border: '1px solid #2B3F6C',
												cursor: 'pointer'
											}}
											onClick={() => {
												setShowModal(true)
												setTitle(data?.title)
												getChecklistDetails(data?.id)
											}}
											avatar={<Avatar src="/images/eye.png" style={{ width: 28, height: 24, padding: 2 }} />}
											label={"View Checklists"}
										/>
										{data?.status == 'active' ?
											<Chip style={{ width: '90px' }}
												color={'DarkGreen'}
												label={data?.status.charAt(0).toUpperCase() + data?.status.slice(1)}
											/> :
											<Chip
												sx={{
													backgroundColor: '#EDE1E1',
													color: '#000000',
													cursor: 'pointer',
													width: '100px'
												}}
												label={data?.status.charAt(0).toUpperCase() + data?.status.slice(1)}
											/>}

										<Link to={`/firehouse/checklist-schedule/${data?.id}`}>
											<Chip
												variant="outlined"
												sx={{
													backgroundColor: '#BF1D2D',
													color: '#FFFFFF', // Dark Blue text
													border: '1px solid #BF1D2D',
													cursor: 'pointer'
												}}
												avatar={<Avatar src="/images/eye1.png" style={{ width: 28, height: 24, padding: 2 }} />}
												label={"Schedule"}
											/>
										</Link>

										{(permission?.includes("Checklist_Auth")) &&
											<div>
												{data?.created_by == user?.Emp_Code ?
													<Chip
														variant="outlined"
														sx={{
															backgroundColor: '#EAECF0',
															color: '#BF1D2D',
															border: '1px solid #BF1D2D',
															cursor: 'pointer'
														}}
														onClick= {()=>deleteChecklist(data?.id)}
														avatar={<Avatar src="/images/delete-red.png" style={{ width: 21, height: 22, padding: 4 }} />}
														label={'Delete'}
													/>
													:
													<Chip
															variant="outlined"
															sx={{
																backgroundColor: '#EAECF0',
																color: '#BF1D2D',
																border: '1px solid #BF1D2D',
															}}
															avatar={<Avatar src="/images/delete-red.png" style={{ width: 21, height: 22, padding: 4 }} />}
															label={'Delete'}
															disabled={true}
														/>
												}
											</div>
										}

										{loading ? 
											<div>
												<CircularProgress size = {18}/>
											</div>
											:
											<Chip
												variant="outlined"
												sx={{
													backgroundColor: '#EAECF0',
													color: '#BF1D2D',
													border: '1px solid #BF1D2D',
													cursor: 'pointer',
													padding:'6px 8px'
												}}
												icon={<img src="/images/print.svg" alt="print" style={{ width: 16, height: 16 }} />}
												label={'Print'}
												onClick={() => {
													handleChecklistData(data.id)
												}}
												disabled={(permission && permission.includes('Emp_Auth') || data?.id?.created_by == user?.Emp_Code) ? false : true}
											/>
										}
										
										<div>
											<Switch
												checked={data?.status == 'active'}
												onChange={
													(permission?.includes("Checklist_Auth"))
														? () => updateChecklistStatus(data?.id, data?.status)
														: undefined
												}
												color="primary"
											/>
										</div>

									</div>
								</div>

								<TableContainer className="font-fam">
									<Table aria-label="simple table">
										<TableHead>
											<TableRow>
												{columns.map((header) => (
													<TableCell
														key={header}
														align="left"
														sx={{
															padding: "0px !important",
															borderBottom: "none !important",
															fontSize: '14px',
															color: '#808080',
															paddingBottom: '16px !important',
															paddingTop: '16px !important',
														}}
													>
														{header}
													</TableCell>
												))}
											</TableRow>
										</TableHead>

										<TableBody>
											<TableRow key={data?.id}>
												<TableCell align="left" sx={{ padding: "1px", borderBottom: "none", fontSize: "14px", minWidth: "150px" }}>
													{data?.duration}
												</TableCell>
												<TableCell align="left" sx={{ padding: "1px", borderBottom: "none", fontSize: "14px", minWidth: "180px" }}>
													{moment(data?.created_at).format("DD MMM YYYY, HH:mm, ddd")}
												</TableCell>
												<TableCell align="left" sx={{ padding: "1px", borderBottom: "none", fontSize: "14px", minWidth: "150px" }}>
													{data?.location.location_description}
												</TableCell>
												<TableCell align="left" sx={{ padding: "1px", borderBottom: "none", fontSize: "14px", minWidth: "150px" }}>
													{data.checklist_assign?.employee_full_name ? data.checklist_assign?.employee_full_name : data.checklist_assign?.position_name}
												</TableCell>
												<TableCell align="left" sx={{ padding: "1px", borderBottom: "none", fontSize: "14px", minWidth: "150px" }}>
													{data?.employee_full_name}
												</TableCell>
											</TableRow>
										</TableBody>

									</Table>
								</TableContainer>
							</CardContent>
						</Card>
					</Grid>
				</Grid>
			</div>

			<div ref={printRef} className='print-data-new-data'>
				<div>
					<div className='d-flex align-items-center justify-content-between print-header'>
						Firehouse247
						<div className='text-center'>
							<h4>Checklist Data Report</h4>
						</div>
						<img src='/images/black-logo.png' style={{ width: 60, height: 60 }} />
					</div>

					<div className='mt-2'>
						<h5>Checklist Definition</h5>
						<div className='font-fam p-3 mt-2' 
						style={{display:'flex' , flexDirection:'column' , gap:'6px' , border:'1px solid #cccccc' , borderRadius:'12px' }}>
							<div>
								<p style={{marginBottom:'0px'}}>Title : <strong>{checklistAllData?.title}</strong></p>
							</div>
							<div>
								<p style={{marginBottom:'0px' , paddingTop:'6px'}}>Status : <strong>{checklistAllData?.status}</strong></p>
							</div>
							<div>
								<p style={{marginBottom:'0px', paddingTop:'6px'}}>Duration : <strong>{checklistAllData?.duration}</strong></p>
							</div>
							<div>
								<p style={{marginBottom:'0px' , paddingTop:'6px'}}>Day : <strong>{checklistAllData?.day}</strong></p>
							</div>
							<div>
								<p style={{marginBottom:'0px' , paddingTop:'6px'}}>Time : <strong>{checklistAllData?.time}</strong></p>
							</div>
							<div>
								<p style={{marginBottom:'0px' , paddingTop:'6px'}}>Assigned by : <strong>{checklistAllData?.employee_full_name}</strong></p>
							</div>
							<div>
								<p style={{marginBottom:'0px' , paddingTop:'6px'}}>Assigned to : <strong>{checklistAllData?.checklist_assign?.employee_full_name}</strong></p>
							</div>
							<div>
								<p style={{ marginBottom: "0px" , paddingTop:'6px'}}>
									Notify to :
									<strong>
										{checklistAllData?.notify
											?.map(
												(name) =>
													` ${name.notify_employee_first_name} ${name.notify_employee_last_name}`
											)
											.join(", ")}
									</strong>
								</p>
							</div>
							<div>
								<p style={{marginBottom:'0px' , paddingTop:'6px'}}>Notify Checklist Update to : <strong>{checklistAllData?.notify_checklist_update_to_name}</strong></p>
							</div>
						</div>
					</div>

					{checklistAllData?.description &&
						<div className='mt-4 page-break-never'>
							<h5>Checklist Description</h5>
							<div className='font-fam p-3 mt-2' style={{display:'flex' , flexDirection:'column' , gap:'6px' , border:'1px solid #cccccc' , borderRadius:'12px' }}>
								{checklistAllData?.description}
							</div>
						</div>
					}

					<div className='mt-4'>
						<h5>Checklist</h5>
						<div style={{display:'flex' , flexDirection:'column' }}>
							{checklistDetails && checklistDetails.map((item) => (
								<div style={{display:'flex' , border:'1px solid #e0e0e0'  , borderRadius:'10px'}} className='page-break-never shows-data-side'>
									<div style={{display:'flex' , gap:'6px' , width:'280px' ,  marginTop:'10px' , marginBottom:'6px'}} className='shows-data-side'>
										<div className='font-fam' style={{marginLeft:'10px'}}>
											<Checkbox />
										</div>
										<div>
											{item?.location?.type == 'location' ?
												<img src='/images/Building.png' style={{ width: 25, height: 30 }} />
												: item?.location?.type	 == 'location_item' ?
												<img src="/images/location-item.svg" style={{ width: 23, height: 23 }} />
												:
												<img src="/images/location-blue.svg" style={{ width: 25, height: 25 }} />
										}
										</div>
										<div
											style={{marginTop:item?.location?.type == 'location' ? '5px' : '3px' , marginLeft:item?.location?.type == 'location' ? '-4px' : ''}}
										>
											{(() => {
												const desc = item?.item_location?.item?.item_description || item?.location?.location_description;
												return desc ? desc.replace(/\w\S*/g, w => w.charAt(0).toUpperCase() + w.slice(1)) : '';
											})()}
										</div>
									</div>
									<div style={{marginTop:'10px'}}>
										{item.description ? 
											<p>Description : <span> {item.description}</span></p> : 
											<p>Description : <span style={{color:'#cccccc'}}>No description</span>
										</p>
										}
									</div>
								</div>
							))}
						</div>
					</div>
				</div>
			</div>
		</>
	)
}
export default ChecklistCard;
